export enum UploadType {
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
  ATTACHMENT = 'attachment',
  MODEL3D = 'model_3d'
}

export interface UploadOptions {
  checkPublish: boolean;
  uploadAsAttachments: boolean;
}

export interface UploadRetryOptions {
  maxAttempts?: number
  baseDelay?: number;
  maxDelay?: number;
  /** Return false to stop retrying after this error. Errors are `{status, statusText}` or a thrown value. */
  isRetryable?: (error: any) => boolean;
}

/** One part of a DMS multipart upload, as returned by the backend (P10-900). */
export interface MultipartPart {
  partNumber: number;
  etagId: string | null;
  url: string;
  headers: unknown;
}

/** The DMS `multipart` object. The client only fills in `etagId`; every other field goes back unchanged. */
export interface MultipartDescriptor {
  uploadId: string;
  bucketName: string;
  targetPath: string;
  partCount: number;
  parts: MultipartPart[];
}

export interface MultipartOrder {
  part_size: number;
  descriptor: MultipartDescriptor;
}

/** Response of `<type>/order_upload_url`. `multipart` is only present when the backend chose multipart. */
export interface OrderUploadResponse {
  artifact_id: string;
  url: string | null;
  multipart?: MultipartOrder;
}

export interface UploadItem {
  id: string;
  uploadType: UploadType,
  artifactId: string | null;
  fileName: string;
  state: 'pending' | 'uploading' | 'success' | 'failed';
  status: number;
  statusText: string;
  uploadStatus: string | null;
  uploadStatusText: string | null;
  uploadStatusCounter: number | null;
}

export interface UploadResult {
  uploadStatus: string;
  statusText: string;
  startTime: Date;
  endTime: Date | null;
  items: UploadItem[];
}
